export default function(query, param) {
  const toRemovePrefix = encodeURIComponent(param) + '='
  const searchQuery = query.split('?')[1]
  const params = searchQuery.split(/[&;]/g)

  const result = params.filter(q => !q.includes(toRemovePrefix))

  if (result.length === 0) {
    return ''
  }

  return `?${result.join('&')}`
}
